export class TabelaEdital {
	loading = true;
	colunas?: { field: string; header: string; pipe: string }[];
	paginaAtual = 1;
	totalResultado?: number;
	primeiroItem = 0;
	itensPorPagina = 5;
}
